var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobDetailsNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 225,
    viewBox: "0 0 220 225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(41.003 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13335",
    "data-name": "Group 13335",
    transform: "translate(24.802 42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M95,190C42.775,190,0,147.612,0,95.249S42.775,0,95,0s95,42.887,95,95.249S147.225,190,95,190Z",
    transform: "translate(-65.805 -37)",
    fill: "#bce8ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1531",
    "data-name": "Ellipse 1531",
    cx: 10.049,
    cy: 10.057,
    rx: 10.049,
    ry: 10.057,
    transform: "translate(20.019 94.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7653",
    "data-name": "Path 7653",
    d: "M501.127,220.37a29.092,29.092,0,0,0-28.788,28.6c0,.145,0,1.165,0,2.5a7.375,7.375,0,0,0,7.371,7.378h0a7.38,7.38,0,0,0,7.375-7.388c0-.909,0-1.538,0-1.576a13.983,13.983,0,1,1,21.523,11.78l0,0s-10.492,6.76-13.691,16.034h0a20.562,20.562,0,0,0-.846,5.852c0,.814.048,7.941.14,13.725a7.6,7.6,0,0,0,7.6,7.482h0a7.6,7.6,0,0,0,7.6-7.654c-.032-5.3-.049-11.465-.049-11.913,0-5.694,5.489-11.368,10-15.068a30.35,30.35,0,0,0,10.429-16.616,18.984,18.984,0,0,0,.546-4.118,29.011,29.011,0,0,0-29.21-29.023Z",
    transform: "translate(-472.142 -220.369)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10036",
    "data-name": "Group 10036",
    transform: "translate(4.998 113)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_468",
    "data-name": "Ellipse 468",
    cx: 83.5,
    cy: 10.5,
    rx: 83.5,
    ry: 10.5,
    transform: "translate(7 96)",
    fill: "#6639b7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1433",
    "data-name": "Ellipse 1433",
    cx: 32.924,
    cy: 36.722,
    rx: 32.924,
    ry: 36.722,
    transform: "translate(103.12 36.556)",
    fill: "#8d8d8d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8609",
    "data-name": "Group 8609",
    transform: "translate(143.245 55.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8607",
    "data-name": "Group 8607",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8611",
    "data-name": "Group 8611",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6365",
    "data-name": "Path 6365",
    d: "M180.166,602.057s26.14-12.034,16.957-20.378S180.166,602.057,180.166,602.057Z",
    transform: "translate(-168.324 -567.21)",
    fill: "#afd6a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6366",
    "data-name": "Path 6366",
    d: "M254.64,562.185s12.015-39.477-5.677-37.589S254.64,562.185,254.64,562.185Z",
    transform: "translate(-242.342 -524.53)",
    fill: "#afd6a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6367",
    "data-name": "Path 6367",
    d: "M237.165,671.265l-.5,6.6-.008.114a30.35,30.35,0,0,1-.156,3.088c-.684,6.736-3.626,9.8-7.064,9.8s-6.252-3.069-6.936-9.8a30.407,30.407,0,0,1-.156-3.088l0-.092,0-.022-.506-6.6Z",
    transform: "translate(-216.108 -637.113)",
    fill: "#ffc179"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6368",
    "data-name": "Path 6368",
    d: "M224,699.636l0,.022,0,.092a30.4,30.4,0,0,0,.156,3.088h14a30.419,30.419,0,0,0,.156-3.088l.008-.114Z",
    transform: "translate(-217.769 -658.88)",
    fill: "#d9a569"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8610",
    "data-name": "Group 8610",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8607-2",
    "data-name": "Group 8607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6379",
    "data-name": "Path 6379",
    d: "M667.405,718.828c7.675-.233,15.056-.16,22.05.313a4.671,4.671,0,0,0,4.976-4.289l.42-5.249,5.948-9.517-5.155-5.154c-8.663,8.628-18.164,15.875-29.447,20.183a2.035,2.035,0,0,0,1.209,3.712Z",
    transform: "translate(-656.582 -610.743)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6380",
    "data-name": "Path 6380",
    d: "M503.742,629.836c.225.4.451.8.817,1.449-.074,12.44,18.915,28.057,31.3,34.24,15.6,5.148,27-1.673,35.886-15.663L545.972,632.81l-3.767,3.767L508.065,616.6a4.359,4.359,0,0,0-6.132.136l-30.792,33.127,5.659,6.284Z",
    transform: "translate(-444.929 -555.964)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6376",
    "data-name": "Path 6376",
    d: "M554.584,522.344h0a4.905,4.905,0,0,1,5.654,4.1l1.918,12.589-6.526,1.732-4.783-11.73a4.9,4.9,0,0,1,3.737-6.69Z",
    transform: "translate(-466.136 -501.122)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6377",
    "data-name": "Path 6377",
    d: "M456.113,558.714c-3.622,14.4-2.063,27.562,11.425,37.9,16.178-4.46,26.938-15.219,33.5-30.857a7.8,7.8,0,0,0-4.5-10.347h0a7.8,7.8,0,0,0-8.589,2.214l-15.874,18.321-7.447-18.474Z",
    transform: "translate(-367.544 -521.56)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45632",
    "data-name": "Path 45632",
    d: "M667.405,718.828c7.675-.233,15.056-.16,22.05.313a4.671,4.671,0,0,0,4.976-4.289l.42-5.249,5.948-9.517-5.155-5.154c-8.663,8.628-18.164,15.875-29.447,20.183a2.035,2.035,0,0,0,1.209,3.712Z",
    transform: "translate(-650.313 -607.584)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6381",
    "data-name": "Path 6381",
    d: "M484.379,539.461l19.109-19.532-4.616-17.922-25.085,26.274Z",
    transform: "translate(-439.76 -434.088)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1425",
    "data-name": "Ellipse 1425",
    cx: 13.482,
    cy: 13.482,
    r: 13.482,
    transform: "translate(114.328 4.629)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6382",
    "data-name": "Path 6382",
    d: "M441.312,549.983l15.068-5.155a18.715,18.715,0,0,1-2.776-11.9H441.312A64.705,64.705,0,0,1,441.312,549.983Z",
    transform: "translate(-317.07 -507.672)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6423",
    "data-name": "Path 6423",
    d: "M419.481,601.625c2.259.928,4.852,9.746,6.988,10.768,10.325,4.94,18.466,11.445,25.965,18.556,17.524-11.9,37.381-58.844,16.3-75.016-7.195,4.21-13.621,7.223-13.482,0Z",
    transform: "translate(-332.072 -522.539)",
    fill: "rgba(0,0,0,0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6383",
    "data-name": "Path 6383",
    d: "M419.6,602.813c2.259.928,3.476,8.348,5.612,9.37a97.768,97.768,0,0,1,25.83,17.97c17.524-11.9,38.924-58.048,17.846-74.22-7.195,4.21-13.621,7.223-13.482,0Z",
    transform: "translate(-330.773 -523.702)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6384",
    "data-name": "Path 6384",
    d: "M433.288,609.878l2.668.847,6.488-23.357c.45-1.62,1.179-.8,2.226.326a7.8,7.8,0,0,1,13.087,5.376c.772,16.942-4.337,31.276-17.042,42.24-10.13-7.24-8.168,2.5-13.571-8.014l.505-.414Z",
    transform: "translate(-312.904 -540.809)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6385",
    "data-name": "Path 6385",
    d: "M441.788,467.63c-4.447,1.016-9.509,2.455-9.793,3.794-4.575,1.153-8.027,3.914-8.733,8.124a2.521,2.521,0,0,0,2.529,2.924c2.488-.032,6.223-.27,8.689-1.3,7.164,4.616,8.367,16.622,5.238,24.794l4.923-.451,5.093-14.911,1.3,14.324,11.235-1.485-1.447-18.266a27.217,27.217,0,0,0-4.274-12.068,10.236,10.236,0,0,0-.8-1.042A14.279,14.279,0,0,0,441.788,467.63Z",
    transform: "translate(-315.792 -467.251)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6386",
    "data-name": "Path 6386",
    d: "M411.132,404.169l-12.339,14.506-18.508-21.843,12.506-15.174Z",
    transform: "translate(-310.483 -359.404)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6387",
    "data-name": "Path 6387",
    d: "M574.275,544.649l14.674-12.006c-.834-2-4.836-1.334-4.836-1.334l-11.486,11.645a6.289,6.289,0,0,0-1.02,1.361h0Z",
    transform: "translate(-501.306 -506.58)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6388",
    "data-name": "Path 6388",
    d: "M524.152,543.216l16.674-13.005,18.509,28.013L541.91,569.979a3.9,3.9,0,0,1-3.335-.5l-17.007-26.012Z",
    transform: "translate(-451.85 -506.226)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3751",
    "data-name": "Rectangle 3751",
    width: 0.27,
    height: 13.142,
    transform: "translate(76.381 36.119) rotate(-125.701)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3752",
    "data-name": "Rectangle 3752",
    width: 25.39,
    height: 0.27,
    transform: "matrix(-0.552, -0.834, 0.834, -0.552, 89.863, 59.644)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3753",
    "data-name": "Rectangle 3753",
    width: 0.27,
    height: 14.074,
    transform: "translate(91.728 60.122) rotate(-126.344)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3754",
    "data-name": "Rectangle 3754",
    width: 25.394,
    height: 0.27,
    transform: "matrix(-0.571, -0.821, 0.821, -0.571, 103.206, 49.468)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3755",
    "data-name": "Rectangle 3755",
    width: 0.167,
    height: 17.909,
    transform: "translate(71.358 36.804) rotate(-132.545)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3756",
    "data-name": "Rectangle 3756",
    width: 0.167,
    height: 18.395,
    transform: "translate(71.858 36.975) rotate(-131.439)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3757",
    "data-name": "Rectangle 3757",
    width: 0.167,
    height: 18.636,
    transform: "matrix(-0.64, -0.768, 0.768, -0.64, 72.194, 36.971)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6389",
    "data-name": "Path 6389",
    d: "M517.507,591.756h0a4.9,4.9,0,0,1,6.866,1.28l20.2,23.842s2.5,16.275-4.392,11.906S517,599.4,517,599.4a4.9,4.9,0,0,1,.508-7.646Z",
    transform: "translate(-423.519 -543.754)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6390",
    "data-name": "Path 6390",
    d: "M427.143,624.049c2.352,1.352,3.384,2.169,3.718,3.532,1.415.8-4.109-1,8.653,1.729,12.7-10.964,17.814-25.3,17.042-42.24a7.806,7.806,0,0,0-8.5-7.418h0a7.8,7.8,0,0,0-6.81,5.682l-6.488,23.357-2.28-1.491Z",
    transform: "translate(-311.704 -537.074)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1638",
    "data-name": "Ellipse 1638",
    cx: 5.5,
    cy: 7,
    rx: 5.5,
    ry: 7,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 85.648, 40.689)",
    fill: "#a0616a"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobDetailsNotFound);
export default __webpack_public_path__ + "static/media/jobDetailsNotFound.590307944f4f891b9ca695541629802f.svg";
export { ForwardRef as ReactComponent };